import { NgModule } from '@angular/core';

import { FilterPipe, LIB_CommonModule, SearchPipe, SorterPipe } from 'pbc.angular';

import { DateiArtsService } from '.';

@NgModule({
  imports: [LIB_CommonModule],
  providers: [DateiArtsService, SearchPipe, FilterPipe, SorterPipe],
  exports: [],
})
export class DateiArtsServiceModule {}
